import { render, staticRenderFns } from "./Comp.vue?vue&type=template&id=3c7e7df8&"
import script from "./Comp.vue?vue&type=script&lang=ts&"
export * from "./Comp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports